import { render } from "./SaferPet.vue?vue&type=template&id=ec27c6d6"
import script from "./SaferPet.vue?vue&type=script&lang=js"
export * from "./SaferPet.vue?vue&type=script&lang=js"

import exportComponent from "/home/cherry/safer_pet/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__